import { DOCUMENT, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

import { SDK } from '@plugins/middleware-sdk';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppGuard {
  #sdk = inject(SDK);
  #locale = inject(LOCALE_ID) as unknown as Promise<string>;
  #document = inject(DOCUMENT);
  #translateService = inject(TranslateService);

  #initialized: boolean;

  async canActivate(): Promise<boolean> {
    if (this.#initialized) {
      return true;
    }
    this.#sdk.initHeightObserver({ min: 150 });
    await this.setTranslations();
    this.#initialized = true;
    return true;
  }

  private async setTranslations() {
    registerLocaleData(localeDe);
    const locale = await this.#locale;
    this.#document.documentElement.lang = locale;
    await lastValueFrom(this.#translateService.use(locale));
    this.#translateService.setDefaultLang(environment.languages.at(0));
  }
}
